const imageProcessing = 'imageProcessing'

export const imageProcessingAction = {
  verification: `${imageProcessing}/verification`,
  detection: `${imageProcessing}/detection`,
}

export const profileAction = 'profile'
